import { lazy } from 'react';

import { ALLOWED_ROLES, REMOTE_CONFIG_KEYS, withRemoteConfigKey } from '@src/packages/utils';

import { PATHS } from './constants';

const LocationAlerts = lazy(() => import('./screens/LocationAlerts'));
const LocationAlertDetails = lazy(() => import('./screens/LocationAlertDetails'));

const monitoringRoutes = [
  {
    component: LocationAlerts,
    path: PATHS.LOCATION_ALERTS,
    exact: true,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.LOCATION_ALERTS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
  {
    component: LocationAlertDetails,
    path: PATHS.LOCATION_ALERT_DETAILS,
    allowedRoles: ALLOWED_ROLES.ORGANIZATIONS.LOCATION_ALERTS.LIST,
    onOrgChangeRedirectTo: `/:orgId/-/${PATHS.BASE_URL}`,
  },
];

export default withRemoteConfigKey(REMOTE_CONFIG_KEYS.LOCATION_ALERTS, monitoringRoutes);
